export const deliveryEstimateTime = (orders) => {
  const ordersTimes = orders
    ?.filter(order => order?.product?.preparing_time != null)
    .map(order => Number(order.product.preparing_time));
  if (ordersTimes.length > 0) {
    const maxTime = Math.max(...ordersTimes);
    if (maxTime <= 60) {
      return `00:${maxTime} min`;
    } else {
      const hours = Math.floor(maxTime / 60);
      const minutes = maxTime % 60;
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} min`;
    }
  } else {
    return null
  }

};
